module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"warning":"Process applications on behalf of someone else in an incognito window (Shift + CMND + N)"}}')
  delete Component.options._Ctor
}
